import React, { useState } from 'react';
import './AltPlatformBar.css';

const PLATFORMS = [
  {
    key: 'instagram', name: 'Instagram',
    glyph: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="2" y="2" width="20" height="20" rx="5.6" />
        <circle cx="12" cy="12" r="4.6" />
        <circle cx="17.7" cy="6.3" r="1.25" fill="currentColor" stroke="none" />
      </svg>
    ),
    brand: '#E4405F',
  },
  {
    key: 'tiktok', name: 'TikTok',
    glyph: (
      <svg viewBox="0 0 24 24" fill="currentColor">
        <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.08-.14 1.62.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
      </svg>
    ),
    brand: '#EE1D52',
  },
  {
    key: 'youtube', name: 'YouTube',
    glyph: (
      <svg viewBox="0 0 24 24" fill="currentColor">
        <path fillRule="evenodd" d="M23.5 6.5a3 3 0 0 0-2.1-2.1C19.5 4 12 4 12 4s-7.5 0-9.4.4A3 3 0 0 0 .5 6.5 31 31 0 0 0 0 12a31 31 0 0 0 .5 5.5 3 3 0 0 0 2.1 2.1C4.5 20 12 20 12 20s7.5 0 9.4-.4a3 3 0 0 0 2.1-2.1A31 31 0 0 0 24 12a31 31 0 0 0-.5-5.5ZM9.6 15.6V8.4l6.3 3.6Z" />
      </svg>
    ),
    brand: '#FF0000',
  },
  {
    key: 'x', name: 'X',
    glyph: (
      <svg viewBox="0 0 24 24" fill="currentColor">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
      </svg>
    ),
    brand: '#FFFFFF',
  },
  {
    key: 'twitch', name: 'Twitch',
    glyph: (
      <svg viewBox="0 0 24 24" fill="currentColor">
        <path d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0 1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714z" />
      </svg>
    ),
    brand: '#9146FF',
  },
  {
    key: 'patreon', name: 'Patreon',
    glyph: (
      <svg viewBox="0 0 24 24" fill="currentColor">
        <path d="M0 .48v23.04h4.22V.48zm15.385 0c-4.764 0-8.641 3.88-8.641 8.65 0 4.755 3.877 8.623 8.641 8.623 4.75 0 8.615-3.868 8.615-8.623C24 4.36 20.136.48 15.385.48z" />
      </svg>
    ),
    brand: '#FF424D',
  },
];

const ACCENT = '#009ffd';
const EYEBROW = 'Creators from every platform sell on Premsi';

function Eyebrow() {
  return (
    <div className="apb-eyebrow-row">
      <span className="apb-eyebrow-line apb-eyebrow-line--left" />
      <span className="apb-eyebrow-text">
        {EYEBROW.split('Premsi')[0]}
        <span style={{ color: ACCENT }}>Premsi</span>
        {EYEBROW.split('Premsi')[1]}
      </span>
      <span className="apb-eyebrow-line apb-eyebrow-line--right" />
    </div>
  );
}

function Chip({ platform }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      className={`apb-chip${hovered ? ' apb-chip--hover' : ''}`}
      style={hovered ? { borderColor: ACCENT + '66', color: platform.brand, boxShadow: `0 12px 28px ${ACCENT}22` } : {}}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <span className="apb-chip-icon">{platform.glyph}</span>
      <span className="apb-chip-name">{platform.name}</span>
    </div>
  );
}

export default function AltPlatformBar() {
  return (
    <section className="apb-section">
      <div className="apb-inner">
        <Eyebrow />
        <div className="apb-chips">
          {PLATFORMS.map((p) => <Chip key={p.key} platform={p} />)}
        </div>
      </div>
    </section>
  );
}
